var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeEquipe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 143.422 105.700",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 11.509 37.177 L 0.809 23.217 C -0.521 21.487 -0.171 18.818 1.569 17.248 L 20.229 0.518 C 21.059 -0.222 22.239 -0.163 22.869 0.657 L 34.829 16.268 C 35.459 17.088 35.299 18.357 34.469 19.097 L 14.149 37.317 C 13.319 38.067 12.139 37.997 11.509 37.177 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 0.657 64.923)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 8.97 13.46 L 9.802 12.906 L 0.832 -0.555 L 0 0 L -0.832 0.555 L 8.138 14.015 L 8.97 13.46 Z",
    fill: "rgb(250,243,255)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 53.236 6.730)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 20.46 L 1 20.465 L 1.11 0.005 L 0.11 0 L -0.89 -0.005 L -1 20.455 L 0 20.46 Z",
    fill: "rgb(250,243,255)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 72.086 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 14.77 L 0.863 15.275 L 9.503 0.505 L 8.64 0 L 7.777 -0.505 L -0.863 14.265 L 0 14.77 Z",
    fill: "rgb(250,243,255)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 82.726 5.610)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 34.79 2.416 L 0 35.036 L 15.39 51.046 L 45.45 22.636 C 51.19 17.216 51.92 8.676 47.09 3.566 L 45.71 2.106 C 42.95 -0.824 38.07 -0.674 34.79 2.416 Z",
    fill: "rgb(135,195,190)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 18.466 33.374)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 48.51 44.6 L 0 25.81 L 10.05 0 L 51.47 16.13 C 57.28 18.39 60.07 25.18 57.69 31.28 L 48.51 44.6 Z",
    fill: "rgb(135,195,190)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 8.826 16.100)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 25.013 15.483 L 10.243 0.712 C 9.293 -0.238 7.763 -0.238 6.813 0.712 L 0.712 6.813 C -0.238 7.763 -0.238 9.293 0.712 10.243 L 15.483 25.013 C 16.433 25.963 17.962 25.963 18.912 25.013 L 25.013 18.913 C 25.953 17.973 25.953 16.433 25.013 15.483 Z",
    fill: "rgb(90,170,160)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 18.044 59.368)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.68 3.36 C 2.608 3.36 3.36 2.608 3.36 1.68 C 3.36 0.752 2.608 0 1.68 0 C 0.752 0 0 0.752 0 1.68 C 0 2.608 0.752 3.36 1.68 3.36 Z",
    fill: "rgb(135,195,190)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 24.076 66.170)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.076 17.416 L 3.076 17.356 C 1.266 17.246 -0.104 15.696 0.006 13.886 L 0.666 3.076 C 0.776 1.266 2.326 -0.104 4.136 0.006 L 5.136 0.066 C 6.946 0.176 8.316 1.726 8.206 3.536 L 7.546 14.346 C 7.436 16.156 5.876 17.526 4.076 17.416 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 0 82.674)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.496 17.386 L 2.916 17.346 C 1.206 17.246 -0.104 15.766 0.006 14.056 L 0.686 2.916 C 0.786 1.206 2.266 -0.104 3.976 0.006 L 4.557 0.046 C 6.267 0.146 7.576 1.627 7.466 3.337 L 6.786 14.476 C 6.686 16.176 5.216 17.486 3.496 17.386 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 6.270 85.354)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.496 17.386 L 2.916 17.346 C 1.206 17.246 -0.104 15.766 0.006 14.056 L 0.686 2.917 C 0.786 1.207 2.266 -0.104 3.976 0.006 L 4.557 0.046 C 6.267 0.146 7.576 1.627 7.466 3.337 L 6.786 14.477 C 6.686 16.187 5.216 17.486 3.496 17.386 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 11.530 87.194)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.496 17.386 L 2.916 17.346 C 1.206 17.246 -0.104 15.767 0.006 14.057 L 0.686 2.917 C 0.786 1.207 2.266 -0.104 3.976 0.006 L 4.556 0.046 C 6.266 0.146 7.576 1.627 7.466 3.337 L 6.786 14.477 C 6.686 16.187 5.206 17.496 3.496 17.386 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 17.590 87.884)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 23.715 37.167 L 34.415 23.217 C 35.735 21.487 35.395 18.817 33.645 17.247 L 14.985 0.517 C 14.155 -0.223 12.975 -0.163 12.345 0.657 L 0.385 16.257 C -0.245 17.077 -0.085 18.347 0.745 19.087 L 21.065 37.307 C 21.905 38.047 23.085 37.987 23.715 37.167 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 107.511 65.033)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 15.493 2.416 L 50.284 35.036 L 34.893 51.046 L 4.834 22.636 C -0.906 17.216 -1.637 8.676 3.193 3.566 L 4.574 2.106 C 7.334 -0.824 12.213 -0.674 15.493 2.416 Z",
    fill: "rgb(180,175,210)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 74.723 33.374)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 10.023 44.54 L 58.383 25.81 L 48.333 0 L 7.043 16.08 C 1.243 18.34 -1.527 25.12 0.853 31.22 L 10.023 44.54 Z",
    fill: "rgb(180,175,210)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 76.103 16.170)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 0.54 16.117 L 16.11 0.548 C 16.84 -0.183 18.01 -0.183 18.74 0.548 L 25.64 7.447 C 26.37 8.177 26.37 9.347 25.64 10.077 L 10.07 25.648 C 9.34 26.378 8.17 26.378 7.44 25.648 L 0.54 18.748 C -0.18 18.028 -0.18 16.847 0.54 16.117 Z",
    fill: "rgb(145,135,175)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 99.476 59.133)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 1.68 3.36 C 2.608 3.36 3.36 2.608 3.36 1.68 C 3.36 0.752 2.608 0 1.68 0 C 0.752 0 0 0.752 0 1.68 C 0 2.608 0.752 3.36 1.68 3.36 Z",
    fill: "rgb(180,175,210)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 116.036 66.170)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.126 17.406 L 5.116 17.346 C 6.916 17.236 8.296 15.686 8.186 13.886 L 7.526 3.076 C 7.416 1.276 5.866 -0.104 4.066 0.006 L 3.076 0.066 C 1.276 0.176 -0.104 1.726 0.006 3.526 L 0.666 14.336 C 0.766 16.146 2.316 17.516 4.126 17.406 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 135.230 82.684)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.975 17.396 L 4.545 17.355 C 6.255 17.255 7.555 15.785 7.455 14.065 L 6.775 2.916 C 6.675 1.206 5.205 -0.095 3.485 0.005 L 2.916 0.036 C 1.206 0.136 -0.095 1.616 0.005 3.326 L 0.685 14.476 C 0.795 16.196 2.265 17.496 3.975 17.396 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 129.691 85.345)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.975 17.385 L 4.545 17.355 C 6.255 17.255 7.555 15.785 7.455 14.065 L 6.775 2.916 C 6.675 1.206 5.205 -0.095 3.485 0.005 L 2.915 0.035 C 1.205 0.135 -0.095 1.605 0.005 3.325 L 0.685 14.476 C 0.795 16.186 2.265 17.485 3.975 17.385 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 124.451 87.195)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 3.975 17.395 L 4.545 17.355 C 6.255 17.255 7.555 15.785 7.455 14.065 L 6.775 2.915 C 6.675 1.205 5.205 -0.095 3.485 0.005 L 2.916 0.035 C 1.206 0.135 -0.095 1.615 0.005 3.325 L 0.686 14.475 C 0.786 16.195 2.265 17.505 3.975 17.395 Z",
    fill: "rgb(252,252,48)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 118.411 87.875)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 12.54 L 0.5 12.54 L 0.5 0 L 0 0 L -0.5 0 L -0.5 12.54 L 0 12.54 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 6.236 89.700)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 11.54 L 0.5 11.54 L 0.5 0 L 0 0 L -0.5 0 L -0.5 11.54 L 0 11.54 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 11.736 91.850)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 11.54 L 0.5 11.54 L 0.5 0 L 0 0 L -0.5 0 L -0.5 11.54 L 0 11.54 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 17.736 94.160)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 12.54 L 0.5 12.54 L 0.5 0 L 0 0 L -0.5 0 L -0.5 12.54 L 0 12.54 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 137.736 89.700)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 11.54 L 0.5 11.54 L 0.5 0 L 0 0 L -0.5 0 L -0.5 11.54 L 0 11.54 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 132.236 91.850)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 11.54 L 0.5 11.54 L 0.5 0 L 0 0 L -0.5 0 L -0.5 11.54 L 0 11.54 Z",
    fill: "rgb(0,45,75)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 1 126.236 94.160)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeEquipe);
export default __webpack_public_path__ + "static/media/time-equipe.ba472c736db31e1d7a71f4a226c190fb.svg";
export { ForwardRef as ReactComponent };